import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  type: 0,
  types: {},
  group: [],
  members: []
}

const mutations = {
  [types.TICKET_TYPES] (state, data) {
    state.types = data
  },
  [types.TICKET_TYPE] (state, data) {
    state.type = data
  },
  [types.TICKET_GROUP] (state, data) {
    state.group = data
  },
  [types.TICKET_MEMBERS] (state, data) {
    state.members = data
  }
}

export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}



// WEBPACK FOOTER //
// ./src/vuex/tickets/store.js